import { render } from "./generalFiles.vue?vue&type=template&id=a0cdc3f0&scoped=true"
import script from "./generalFiles.js?vue&type=script&lang=js"
export * from "./generalFiles.js?vue&type=script&lang=js"

import "./generalFiles.vue?vue&type=style&index=0&id=a0cdc3f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0cdc3f0"]])

export default __exports__